export default function MySQL_CONSTRAINTS() {
  return (
    <div>
      <h2>MySQL_CONSTRAINTS</h2>    </div>
  );
}